import { useCallback, useMemo, useState } from 'react';

import { useCurrentUser } from '@bonusly/who-am-i';

import { ProxyPrincipal } from '../../../../queries/recognition-proxies';

// PROXY GIVING (POC)

export interface UseProxyGivingResult {
	principals: ProxyPrincipal[];
	selectedPrincipal: ProxyPrincipal | null;
	selectPrincipal: (principal: ProxyPrincipal) => void;
	clearSelection: () => void;
	hasProxyRights: boolean;
	isLoading: boolean;
}

export const useProxyGiving = (): UseProxyGivingResult => {
	const [selectedPrincipal, setSelectedPrincipal] = useState<ProxyPrincipal | null>(null);
	const user = useCurrentUser();

	const principals: ProxyPrincipal[] = useMemo(
		() =>
			(user?.proxy_principals ?? []).map((p) => ({
				id: p.id,
				name: p.name,
				profilePicUrl: p.profile_pic_url,
				givingBalance: p.giving_balance,
			})),
		[user?.proxy_principals]
	);

	const selectPrincipal = useCallback((principal: ProxyPrincipal) => {
		setSelectedPrincipal(principal);
	}, []);

	const clearSelection = useCallback(() => {
		setSelectedPrincipal(null);
	}, []);

	const hasProxyRights = principals.length > 0;

	return {
		principals,
		selectedPrincipal,
		selectPrincipal,
		clearSelection,
		hasProxyRights,
		isLoading: false,
	};
};
